import { pageTitle } from "../PageTitle";
import React, { useState } from "react";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import g1 from "../../assets/images/resource/wa-enterprises.png";
// import AiInvoiceBanner from "./../../assets/images/banner/enterprise.png";
// import { Link } from "react-router-dom";
import service1 from "./../../assets/images/banner/arc1.png";
import service2 from "./../../assets/images/banner/arc2.png";
import service3 from "./../../assets/images/banner/arc3.png";
import service4 from "./../../assets/images/banner/arc4.png";


const Wa_Enterprise = () => {
  pageTitle("WhatsApp AI For Enterprise");
  const [popupImage, setPopupImage] = useState(null);
  const handleWhatsAppClick = () => {
    const phoneNumber = "6590059743"; // WhatsApp number (no '+' or spaces)
    const message = "Hello! I would like to know more about your services.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <HeaderOne />
      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${g1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      </section>
      {/* <div
        className="ai-overlay-wrapper-solutions"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-project-text-solutions">
            <h2 className="ai-overlay-project enterprise-h2">
              Secure, Single-Tenant WhatsApp API <br />
              for Enterprise Systems
            </h2>
          </div>
          <div className="siw-hero-price-box-sol">
            
            <Link
              to="/contact"
              className="theme-btn theme-btn-one siw-hero-small-btn"
            >
              TALK TO US
            </Link>
          </div>
        </div>
      </div> */}

      <section className="py-3 py-md-4">
        <div className="container">
          {/* <h3 className="siw-project-heading">
            One WhatsApp message is all it takes, automate your grocery orders instantly.
          </h3> */}

          <div className="row g-4 align-items-stretch">
            <div className="col-lg-12 d-flex">
              <div className="food-grey-box w-100">
                <h3 className="siw-project-heading pb-1">
                  Secure WhatsApp Deployment — Data Controlled by Your Business
                </h3>

                <p className="mb-0 siw-rpa-desc">
                  Deploy the WhatsApp Business API within your own server,
                  private cloud, or internal infrastructure, giving your
                  business stronger control over data, access, and system
                  integration.
                </p>

                <p className="siw-rpa-desc">
                  With a single-tenant setup, your organization can maintain:
                </p>

                <div className="siw-rpa-desc">
                  <ul>
                    <li>
                      Customer conversations stored within your controlled
                      environment
                    </li>
                    <li>
                      Better control over user access, logs, audits, and
                      compliance policies
                    </li>
                    <li>
                      Lower dependency on shared platforms or third-party inbox
                      tools
                    </li>
                    <li>
                      Flexible integration with your CRM, ERP, website, and
                      internal systems
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wa-enterprise-zigzag-section">
        <div className="container">
          {/* 1 */}
          <div className="wa-enterprise-zigzag-row">
            <div className="wa-enterprise-zigzag-image">
              <button
                type="button"
                className="wa-enterprise-image-btn"
                onClick={() =>
                  setPopupImage({
                    src: service1,
                    alt: "Official WhatsApp Business API setup",
                  })
                }
              >
                <img
                  src={service1}
                  alt="Official WhatsApp Business API setup"
                />
              </button>
            </div>

            <div className="wa-enterprise-zigzag-content">
              <h3>
                Official WhatsApp Business API Setup for Reliable Customer
                Engagement
              </h3>

              <p>
                Launch your WhatsApp Business API with the right setup, approval
                guidance, messaging flow, and compliance-ready configuration. We
                help businesses use WhatsApp for customer enquiries, promotions,
                notifications, reminders, and automated support.
              </p>

              <p>
                A proper foundation helps reduce setup mistakes, message
                delivery issues, and policy-related risks while keeping your
                WhatsApp channel stable and business-ready.
              </p>

              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>

          {/* 2 */}
          <div className="wa-enterprise-zigzag-row wa-enterprise-reverse">
            <div className="wa-enterprise-zigzag-image">
              <button
                type="button"
                className="wa-enterprise-image-btn"
                onClick={() =>
                  setPopupImage({
                    src: service2,
                    alt: "WhatsApp automation and AI chatbot",
                  })
                }
              >
                <img src={service2} alt="WhatsApp automation and AI chatbot" />
              </button>
            </div>

            <div className="wa-enterprise-zigzag-content">
              <h3>
                WhatsApp Automation for Sales, Support, Orders, and Follow-ups
              </h3>

              <p>
                Turn WhatsApp into an automated business channel for customer
                chats, order confirmations, reminders, support replies, lead
                capture, and follow-up messages. Your workflows can be connected
                with your CRM, website, backend system, or business dashboard.
              </p>

              <p>
                Start with simple automation and expand into AI-powered
                conversations, document capture, order handling, and customer
                service flows as your business grows.
              </p>

              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>

          {/* 3 */}
          <div className="wa-enterprise-zigzag-row">
            <div className="wa-enterprise-zigzag-image">
              <button
                type="button"
                className="wa-enterprise-image-btn"
                onClick={() =>
                  setPopupImage({
                    src: service3,
                    alt: "Private WhatsApp architecture",
                  })
                }
              >
                <img src={service3} alt="Private WhatsApp architecture" />
              </button>
            </div>

            <div className="wa-enterprise-zigzag-content">
              <h3>
                Secure WhatsApp Architecture Designed Around Your Business
                Systems
              </h3>

              <p>
                Build a WhatsApp solution that fits your internal process, data
                flow, and security requirements. We design private and
                structured architectures for businesses that need better control
                over customer conversations, integrations, logs, and reporting.
              </p>

              <p>
                Suitable for companies that want a scalable WhatsApp setup for
                marketing, operations, customer service, ordering, attendance,
                invoicing, and AI automation.
              </p>

              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>

          {/* 4 */}
          <div className="wa-enterprise-zigzag-row wa-enterprise-reverse">
            <div className="wa-enterprise-zigzag-image">
              <button
                type="button"
                className="wa-enterprise-image-btn"
                onClick={() =>
                  setPopupImage({
                    src: service4,
                    alt: "Enterprise WhatsApp implementation",
                  })
                }
              >
                <img src={service4} alt="Enterprise WhatsApp implementation" />
              </button>
            </div>

            <div className="wa-enterprise-zigzag-content">
              <h3>
                End-to-End WhatsApp Implementation with AI, Dashboard, and
                Integration
              </h3>

              <p>
                We help you plan, build, and deploy WhatsApp solutions based on
                your business use case. From chatbot flows and template messages
                to AI agents, order dashboards, invoice automation, attendance
                tracking, and reporting, everything is designed around your
                workflow.
              </p>

              <p>
                Our goal is to help you create a WhatsApp channel that improves
                response time, reduces manual work, and supports measurable
                business growth.
              </p>

              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>
        </div>

        {popupImage && (
          <div
            className="wa-enterprise-popup-overlay"
            onClick={() => setPopupImage(null)}
          >
            <button
              type="button"
              className="wa-enterprise-popup-close"
              onClick={() => setPopupImage(null)}
            >
              ×
            </button>

            <img
              src={popupImage.src}
              alt={popupImage.alt}
              className="wa-enterprise-popup-img"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </section>

      <FooterOne />
    </>
  );
};

export default Wa_Enterprise;
